import Vue from 'vue'
import Vuex from 'vuex'
import Common from './api/common'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		User: {},
		currentAccountSets: {},
		myAccountSets: [],
		myAccountDates: [],
		sliderCollapsed: false
	},
	mutations: {
		updateAccount(state, data) {
			state.User = data;
			state.currentAccountSets = data.accountSets;
			state.myAccountSets = data.accountSetsList;
			state.myAccountDates = data.checkoutList;
		},
		updateSliderCollapse(state, isShow) {
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			state.sliderCollapsed = isShow;
		}
	},
	actions: {
		init(context) {
			return new Promise((resolve, reject) => {
				Common.init().then(({data}) => {
					context.commit('updateAccount', data);
					resolve(data)
				}).catch(() => {
					reject();
				})
			});
		}
	},
	getters: {
		account: state => {
			return state.User;
		},
		checkoutList: state => {
			return state.User.checkoutList;
		},
		firstCheckoutDate: state => {
			let reverse = state.User.checkoutList.filter(val => val.status !== 2).reverse();
			if (reverse.length) {
				return reverse[0].checkDate;
			}
			return null;
		},
		checkoutSelect: state => {
			return state.User.checkoutList.map(row => {
				const m = row.checkMonth < 10 ? '0' + row.checkMonth : row.checkMonth;
				return {
					key: row.checkYear + '年' + m + "期",
					title: row.checkYear + '年' + m + "期",
				}
			});
		},
		sliderCollapsed: state => {
			return state.sliderCollapsed;
		}
	}
})
